/*
 *
 *
 * composable
 *
 *
 */
import { reactive } from 'vue'
import { useWebViewEventBus } from '@/composables/web-view-event-bus/index.js'

export function useBluetoothLocationAccess () {
  const webViewEventBus = useWebViewEventBus()

  const checkPermissions = async (feature) => {
    const permissions = await webViewEventBus.sendEventWithCallback(`${feature}.permissions`)
    return {
      accessGranted: permissions.access_granted,
      accessDeniedPermanently: permissions.access_denied_permanently,
    }
  }

  const checkIfEnabled = async (feature) => {
    const data = await webViewEventBus.sendEventWithCallback(`${feature}.enabled`)
    return data.enabled
  }

  const checkAccess = async (feature) => {
    const permissions = await checkPermissions(feature)
    const enabled = await checkIfEnabled(feature)
    return { ...permissions, enabled }
  }

  const location = reactive({
    accessGranted: false,
    accessDeniedPermanently: false,
    enabled: false,
  })

  return {
    location,
    checkPermissions,
    checkIfEnabled,
    checkAccess,
  }
}
